import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const FolderForm_Actor_Remove_Mutation = graphql(`
  mutation FolderForm_Actor_Remove(
    $actorId: Id!
    $actorableId: Id!
    $list: ActorListEnum!
    $versionData: VersionDataInput
  ) {
    removeFolderActor(
      actorId: $actorId
      actorableId: $actorableId
      list: $list
      versionData: $versionData
    ) {
      _id
    }
  }
`);

export const useRemoveFolderActorMutation = () =>
  useGraphQLMutation(FolderForm_Actor_Remove_Mutation);
